import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toast__exclamation_mark",
  "use": "toast__exclamation_mark-usage",
  "viewBox": "0 0 41 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41 42\" id=\"toast__exclamation_mark\">\n  <g fill=\"#fff\">\n    <circle cx=\"21\" cy=\"28.5\" r=\"2.5\" />\n    <path d=\"M21 9.5a2 2 0 0 1 2 2v13h-4v-13a2 2 0 0 1 2-2Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol